import "./App.css";
import { Box } from "@mui/material";
import AllRoutes from "./routes/AllRoutes";

function App() {
  return (
    <Box className="App">
      <AllRoutes />
    </Box>
  );
}

export default App;
